import { CustomIntervalType as CustomIntervalTypeEnum } from "@sinch/core/entities/serverEnums";
import { CustomIntervalType } from "@sinch/types/sinch.types";
import { isNotNil } from "ramda-adjunct";
import { boolean, type InferType, object, string } from "yup";
import { staticCustomIntervalTypeSchemas } from "@sinch/components/application/Rate/useIntervalType";

type SettingsTypes = InferType<(typeof staticCustomIntervalTypeSchemas)[keyof typeof staticCustomIntervalTypeSchemas]>;
export const intervalFormSchema = object({
  name: string().required(),
  description: string(),
  archived: boolean().default(false),
  // @ts-ignore this is ok
  type: string<CustomIntervalType | CustomIntervalTypeEnum>().default("").required(),
  settings: object()
    .when("type", ([type], schema) => {
      const intervalTypeSchema = staticCustomIntervalTypeSchemas[type as CustomIntervalType | CustomIntervalTypeEnum];
      return isNotNil(intervalTypeSchema) ? schema.concat(intervalTypeSchema) : schema;
    })
    .required(),
});
export type CreateIntervalFormData = InferType<typeof intervalFormSchema> & {
  settings: SettingsTypes | Record<string, never>;
};
